import { Component, OnInit } from "@angular/core";
import { HttpHelpService } from "../../service/http-help.service";
import { TranslateService } from "@ngx-translate/core";
import { NgxSpinnerService } from "ngx-spinner";
import { ActivatedRoute, Router } from "@angular/router";
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import Swal from 'sweetalert2';
import { forkJoin } from "rxjs";
import {
  InvoiceSubscriptionsV2Service,
  InvoiceSubscriptionStatus,
  InvoiceSubscriptionPlan,
} from "src/app/services/invoice-subscriptions-v2.service";
import {
  DocumentLanguageCode,
  getDefaultDocumentLanguage,
  setDefaultDocumentLanguage,
} from "src/app/shared/services/document-language-preference";
import {
  ReportLanguageCode,
  getDefaultReportLanguage,
  setDefaultReportLanguage,
} from "src/app/shared/services/report-language-preference";
import { SmartAssistantPreferenceService } from "src/app/shared/services/smart-assistant-preference.service";

@Component({
  selector: "app-update-merchant",
  templateUrl: "./update-merchant.component.html",
  styleUrls: ["./update-merchant.component.scss"]
})

export class UpdateMerchantComponent implements OnInit {
  curentLang:string="";
  layoutVersion:any;
  userRegistId:any = JSON.parse(localStorage.getItem('user_id'));
  merchantId = JSON.parse(localStorage.getItem('merchant_id'));
  user_type = JSON.parse(localStorage.getItem('user_type'));

  merchantInfoData:any=[];
  id:number;
  MerchantNameEn:string;
  MerchantNameAr:string;
  MerchantNameHe:string;
  MerchantAddress:string;
  IdNumber:string;
  public validate = false;
  updateMerchant:FormGroup;
  isSaving = false;
  isEditing = false;
  documentLanguage: DocumentLanguageCode = getDefaultDocumentLanguage();
  reportLanguage: ReportLanguageCode = getDefaultReportLanguage();
  showAssistantButton = false;
  private merchantSnapshot: {
    merchant_name_ar: string;
    merchant_name_en: string;
    merchant_name_he: string;
    merchant_address: string;
    id_number: string;
  } | null = null;

  get isAdminUser(): boolean {
    const ut = Number(this.user_type);
    return ut === 200 || ut === 201;
  }

  /** Unified shape for template (admin or merchant invoice-subscriptions-v2 APIs) */
  v2SubscriptionStatus: any = null;
  v2SubscriptionLoading = false;
  v2SubscriptionError = false;

  get isMerchantUser(): boolean {
    const ut = Number(this.user_type);
    return ut === 100 || ut === 101;
  }

  get displayMerchantName(): string {
    if (this.curentLang === 'ar') {
      return this.MerchantNameAr || this.MerchantNameHe || this.MerchantNameEn || '';
    }
    if (this.curentLang === 'he') {
      return this.MerchantNameHe || this.MerchantNameEn || this.MerchantNameAr || '';
    }
    return this.MerchantNameEn || this.MerchantNameAr || this.MerchantNameHe || '';
  }

  get merchantInitials(): string {
    const name = (this.displayMerchantName || '').trim();
    if (!name) return '—';
    const words = name.split(/\s+/).filter(Boolean);
    if (words.length >= 2) {
      return (words[0].charAt(0) + words[1].charAt(0)).toUpperCase();
    }
    return name.substring(0, 2).toUpperCase();
  }

  get subscriptionTone(): 'ok' | 'warn' | 'danger' | 'neutral' {
    const s = String(this.v2SubscriptionStatus?.subscription?.status || '').toLowerCase();
    if (s === 'active') return 'ok';
    if (s === 'expired') return 'danger';
    if (s === 'cancelled') return 'warn';
    return 'neutral';
  }

  usagePercent(used: number, limit: number): number {
    if (!limit) return 0;
    return Math.min(100, Math.round((Number(used) / Number(limit)) * 100));
  }

  onDocumentLanguageChange(code: string): void {
    this.documentLanguage = setDefaultDocumentLanguage(code);
  }

  onReportLanguageChange(code: string): void {
    this.reportLanguage = setDefaultReportLanguage(code);
  }

  onAssistantToggle(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.assistantPreference.setVisible(!!input?.checked);
    this.showAssistantButton = this.assistantPreference.isVisible();
  }

  getSubscriptionStatusLabel(status: string | undefined): string {
    if (!status) return '—';
    const key = String(status).toLowerCase();
    const map: Record<string, string> = {
      active: this.curentLang === 'ar' ? 'نشط' : (this.curentLang === 'he' ? 'פעיל' : 'Active'),
      expired: this.curentLang === 'ar' ? 'منتهي' : (this.curentLang === 'he' ? 'פג תוקף' : 'Expired'),
      cancelled: this.curentLang === 'ar' ? 'ملغى' : (this.curentLang === 'he' ? 'בוטל' : 'Cancelled'),
    };
    return map[key] || status;
  }

  get showSubscriptionSection(): boolean {
    const ut = Number(this.user_type);
    if (ut === 200 || ut === 201) return true;
    const routeId = Number(this.id);
    const mid = this.merchantId != null ? Number(this.merchantId) : NaN;
    if ([100, 101, 300, 301].includes(ut) && !Number.isNaN(routeId) && routeId === mid) return true;
    return false;
  }

   newOrders = {
    colorClass: "primary",
    icon: "new-order",
    colorClass2: "warning",
    icon2: "customers",
    colorClass3: "success",
    icon4: "invoice",
    colorClass4: "secondary",
    icon3: "profit"
  };

  
  constructor
  (  
     private spinner: NgxSpinnerService ,
    public translate:TranslateService ,
    private service:HttpHelpService  ,
    private invoiceSubscriptionsV2: InvoiceSubscriptionsV2Service,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private fb:FormBuilder,
    private assistantPreference: SmartAssistantPreferenceService,
    ) 
  { 
    this.curentLang = localStorage.getItem('curentLang');
    this.id = this.activatedRoute.snapshot.params['id'];
    this.user_type = JSON.parse(localStorage.getItem('user_type'));
    this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));

  this.updateMerchant = this.fb.group({
    merchant_name_ar: ['', [this.noWhitespaceValidator()]],
    merchant_name_en: ['', [this.noWhitespaceValidator()]],
    merchant_name_he: ['', [Validators.required, this.noWhitespaceValidator()]],
    merchant_address: ['', [this.noWhitespaceValidator()]],
    id_number: ['',[this.noWhitespaceValidator() , Validators.required] ]
  });

  if (this.user_type === 100 || this.user_type === 101) {
    this.updateMerchant.controls['id_number'].disable();
    this.updateMerchant.controls['id_number'].clearValidators();
    this.updateMerchant.controls['id_number'].updateValueAndValidity({ emitEvent: false });
  } else if (this.user_type === 200 || this.user_type === 201) {
    this.updateMerchant.controls['id_number'].enable();
    this.updateMerchant.controls['merchant_name_ar'].enable();
    this.updateMerchant.controls['merchant_name_en'].enable();
    this.updateMerchant.controls['merchant_name_he'].enable();
    this.updateMerchant.controls['merchant_address'].enable();
  }
}

  private enforceOwnMerchantAccess(): boolean {
    if (!this.isMerchantUser) {
      return true;
    }
    const routeId = Number(this.id);
    const mid = Number(this.merchantId);
    if (!mid || Number.isNaN(mid)) {
      this.router.navigate(['/dashboard/dashboard'], { replaceUrl: true });
      return false;
    }
    if (Number.isNaN(routeId) || routeId !== mid) {
      this.router.navigate(['/dashboard/update-merchant', mid], { replaceUrl: true });
      return false;
    }
    return true;
  }

  displayField(value: string | null | undefined): string {
    const v = (value ?? '').toString().trim();
    return v || '—';
  }

  enterEditMode(): void {
    this.isEditing = true;
    this.validate = false;
  }

  cancelEdit(): void {
    this.isEditing = false;
    this.validate = false;
    this.restoreMerchantSnapshot();
  }

  private captureMerchantSnapshot(): void {
    this.merchantSnapshot = {
      merchant_name_ar: this.MerchantNameAr ?? '',
      merchant_name_en: this.MerchantNameEn ?? '',
      merchant_name_he: this.MerchantNameHe ?? '',
      merchant_address: this.MerchantAddress ?? '',
      id_number: this.IdNumber ?? '',
    };
  }

  private restoreMerchantSnapshot(): void {
    if (!this.merchantSnapshot) {
      return;
    }
    this.MerchantNameAr = this.merchantSnapshot.merchant_name_ar;
    this.MerchantNameEn = this.merchantSnapshot.merchant_name_en;
    this.MerchantNameHe = this.merchantSnapshot.merchant_name_he;
    this.MerchantAddress = this.merchantSnapshot.merchant_address;
    this.IdNumber = this.merchantSnapshot.id_number;
    this.applyLoadedMerchantToForm();
    this.updateMerchant.markAsPristine();
    this.updateMerchant.markAsUntouched();
  }

  private applyLoadedMerchantToForm(): void {
    this.updateMerchant.patchValue({
      merchant_name_ar: this.MerchantNameAr ?? '',
      merchant_name_en: this.MerchantNameEn ?? '',
      merchant_name_he: this.MerchantNameHe ?? '',
      merchant_address: this.MerchantAddress ?? '',
      id_number: this.IdNumber ?? '',
    });
  }

  getMerchantInfoById() {
    this.spinner.show();
    this.service.getMerchantInfoById(this.id).subscribe({
      next: res => {
        this.merchantInfoData = res;
        this.MerchantNameEn = this.merchantInfoData[0]?.merchant_name_en;
        this.MerchantNameAr = this.merchantInfoData[0]?.merchant_name_ar;
        this.MerchantNameHe = this.merchantInfoData[0]?.merchant_name_he;
        this.MerchantAddress = this.merchantInfoData[0]?.merchant_address;
        this.IdNumber = this.merchantInfoData[0]?.id_number;
        this.applyLoadedMerchantToForm();
        this.captureMerchantSnapshot();

        this.spinner.hide();
        this.loadInvoiceSubscriptionV2();
      },
      error: () => {
        this.spinner.hide();
      }
    });
  };

  loadInvoiceSubscriptionV2(): void {
    if (!this.showSubscriptionSection) {
      this.v2SubscriptionStatus = null;
      return;
    }
    this.v2SubscriptionLoading = true;
    this.v2SubscriptionError = false;

    const isAdmin = this.user_type === 200 || this.user_type === 201;
    if (isAdmin) {
      this.service.getAdminMerchantSubscriptionStatus(this.id).subscribe({
        next: (res) => {
          this.v2SubscriptionStatus = this.normalizeAdminSubscriptionResponse(res);
          this.v2SubscriptionLoading = false;
        },
        error: () => {
          this.v2SubscriptionLoading = false;
          this.v2SubscriptionError = true;
          this.v2SubscriptionStatus = null;
        },
      });
      return;
    }

    forkJoin({
      status: this.invoiceSubscriptionsV2.getStatus(),
      plans: this.invoiceSubscriptionsV2.getPlans(),
    }).subscribe({
      next: ({ status, plans }) => {
        const planId = status?.subscription?.plan_id;
        const plan = planId ? (plans || []).find((p: InvoiceSubscriptionPlan) => p.id === planId) : undefined;
        this.v2SubscriptionStatus = this.mergeMerchantStatusWithPlan(status, plan);
        this.v2SubscriptionLoading = false;
      },
      error: () => {
        this.v2SubscriptionLoading = false;
        this.v2SubscriptionError = true;
        this.v2SubscriptionStatus = null;
      },
    });
  }

  private normalizeAdminSubscriptionResponse(res: any): any {
    if (!res?.subscription) return res || null;
    const sub = res.subscription;
    if (sub.usage) return res;
    if (
      sub.documents_used !== undefined ||
      sub.documents_limit !== undefined ||
      sub.companies_used !== undefined ||
      sub.companies_limit !== undefined
    ) {
      return {
        ...res,
        subscription: {
          ...sub,
          usage: {
            documents_used: sub.documents_used ?? 0,
            documents_limit: sub.documents_limit ?? 0,
            companies_used: sub.companies_used ?? 0,
            companies_limit: sub.companies_limit ?? 0,
          },
        },
      };
    }
    return res;
  }

  private mergeMerchantStatusWithPlan(
    status: InvoiceSubscriptionStatus | null,
    plan: InvoiceSubscriptionPlan | undefined
  ): any {
    if (!status) return null;
    const s = status.subscription;
    if (!s) {
      return {
        days_remaining: status.days_remaining,
        documents_remaining: status.documents_remaining,
        companies_remaining: status.companies_remaining,
        is_active: status.is_active,
        is_expired: status.is_expired,
        subscription: null,
      };
    }
    const planShim = plan
      ? { id: plan.id, name_ar: plan.name_ar, name_en: plan.name_en, name_he: plan.name_he }
      : { id: s.plan_id };
    return {
      days_remaining: status.days_remaining,
      documents_remaining: status.documents_remaining,
      companies_remaining: status.companies_remaining,
      is_active: status.is_active,
      is_expired: status.is_expired,
      subscription: {
        ...s,
        plan: planShim,
        usage: {
          documents_used: s.documents_used ?? 0,
          documents_limit: s.documents_limit ?? 0,
          companies_used: s.companies_used ?? 0,
          companies_limit: s.companies_limit ?? 0,
        },
      },
    };
  }

  getPlanDisplayName(plan: any): string {
    if (!plan) return "—";
    if (this.curentLang === "ar") return plan.name_ar || plan.name_en || plan.name_he || `#${plan.id}`;
    if (this.curentLang === "he") return plan.name_he || plan.name_en || plan.name_ar || `#${plan.id}`;
    return plan.name_en || plan.name_ar || plan.name_he || `#${plan.id}`;
  }

  getSubscriptionUsage(): { documents_used: number; documents_limit: number; companies_used: number; companies_limit: number } | null {
    const sub = this.v2SubscriptionStatus?.subscription;
    if (!sub) return null;
    const u = sub.usage || this.v2SubscriptionStatus?.usage;
    if (u) {
      return {
        documents_used: u.documents_used ?? 0,
        documents_limit: u.documents_limit ?? 0,
        companies_used: u.companies_used ?? 0,
        companies_limit: u.companies_limit ?? 0,
      };
    }
    if (
      sub.documents_used !== undefined ||
      sub.documents_limit !== undefined ||
      sub.companies_used !== undefined ||
      sub.companies_limit !== undefined
    ) {
      return {
        documents_used: sub.documents_used ?? 0,
        documents_limit: sub.documents_limit ?? 0,
        companies_used: sub.companies_used ?? 0,
        companies_limit: sub.companies_limit ?? 0,
      };
    }
    return null;
  }

  copyPendingPaymentLink(url?: string | null): void {
    const link = url || this.v2SubscriptionStatus?.latest_pending_admin_payment_link;
    if (!link || typeof link !== "string") return;
    if (navigator?.clipboard?.writeText) {
      navigator.clipboard.writeText(link).then(() => {
        Swal.fire({
          icon: "success",
          title: this.curentLang === "ar" ? "تم نسخ رابط الدفع" :
            (this.curentLang === "en" ? "Payment link copied" : "קישור התשלום הועתק")
        });
      }).catch(() => this.copyPaymentLinkFallback(link));
      return;
    }
    this.copyPaymentLinkFallback(link);
  }

  private copyPaymentLinkFallback(link: string): void {
    const textarea = document.createElement("textarea");
    textarea.value = link;
    textarea.style.position = "fixed";
    textarea.style.opacity = "0";
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand("copy");
    document.body.removeChild(textarea);
    Swal.fire({
      icon: "success",
      title: this.curentLang === "ar" ? "تم نسخ رابط الدفع" :
        (this.curentLang === "en" ? "Payment link copied" : "קישור התשלום הועתק")
    });
  }

  isNumber(event: KeyboardEvent) {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      event.preventDefault();
    } else {
      return true;
    }
  }

    noWhitespaceValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { whitespace: true };
    };
  }

  updateMerchantById() {
    if (this.isSaving) {
      return;
    }

    const formValue = this.updateMerchant.getRawValue();
    const merchant_name_he = formValue.merchant_name_he ? formValue.merchant_name_he.trim() : '';
    const merchant_name_en = formValue.merchant_name_en ? formValue.merchant_name_en.trim() : '';
    const merchant_name_ar = formValue.merchant_name_ar ? formValue.merchant_name_ar.trim() : '';
    const merchant_address = formValue.merchant_address ? formValue.merchant_address.trim() : '';
    const id_number = formValue.id_number ? String(formValue.id_number).trim() : '';
  
    if (!merchant_name_he) {
      Swal.fire({
        icon: 'warning',
        title: this.curentLang === 'ar' ? 'يرجى ملء الحقول المطلوبة وعدم تركها فارغة أو تحتوي على مسافات فقط' :
               (this.curentLang === 'en' ? 'Please fill out the required fields and do not leave them empty or containing only spaces' :
               (this.curentLang === 'he' ? 'אנא מלא את השדות הנדרשים ואל תשאיר אותם ריקים או המכילים רק רווחים' : ''))
      });
      this.updateMerchant.markAllAsTouched();
      this.validate = !this.validate;
      return;
    }
  
    if ((this.user_type === 200 || this.user_type === 201) && !id_number) {
      Swal.fire({
        icon: 'warning',
        title: this.curentLang === 'ar' ? 'يرجى إدخال رقم الهوية وعدم تركه فارغاً' :
               (this.curentLang === 'en' ? 'Please enter the ID number and do not leave it empty' :
               (this.curentLang === 'he' ? 'אנא הכנס את מספר הזהות ואל תשאיר אותו ריק' : ''))
      });
      this.updateMerchant.markAllAsTouched();
      this.validate = !this.validate;
      return;
    }
  
    let model: any = {
      merchant_name_en: merchant_name_en,
      merchant_name_ar: merchant_name_ar,
      merchant_name_he: merchant_name_he,
      merchant_address: merchant_address,
      updated_by: Number(this.userRegistId),
    };
  
    if (this.user_type !== 100 && this.user_type !== 101) {
      model.id_number = id_number ? Number(id_number) : null;
    }

    this.isSaving = true;
    this.spinner.show();
    this.service.updateMerchantById(this.id, model).subscribe({
      next: (res) => {
        this.isSaving = false;
        if (res.status == 200) {
          Swal.fire({
            icon: 'success',
            title: this.curentLang == 'ar' ? 'تم التعديل بنجاح' :
                   (this.curentLang == 'en' ? 'Updated successfully' : 'עודכן בהצלחה')
          });
          this.isEditing = false;
          this.validate = false;
          this.getMerchantInfoById();
        } else if (res.status === 400 && res.res.message && res.res.message.length > 0) {
          res.res.message.forEach(() => {
            Swal.fire({
              icon: 'error',
              title: this.curentLang == 'ar' ? 'خطأ' :
                     (this.curentLang == 'en' ? 'Error' : 'שְׁגִיאָה'),
            });
          });
        }
        this.spinner.hide();
      },
      error: () => {
        this.isSaving = false;
        this.spinner.hide();
        Swal.fire({
          icon: 'error',
          title: this.curentLang === 'ar' ? 'فشل حفظ التعديلات' :
            (this.curentLang === 'en' ? 'Failed to save changes' : 'שמירת השינויים נכשלה'),
        });
      },
    });
  }

  ngOnInit() {
    this.showAssistantButton = this.assistantPreference.isVisible();
    if (!this.enforceOwnMerchantAccess()) {
      return;
    }
    this.getMerchantInfoById();
    this.layoutVersion = localStorage.getItem("layout_version");
   if (this.layoutVersion == null || this.layoutVersion == undefined) {
     localStorage.setItem("layout_version", "light-only");
     this.layoutVersion= "light-only"; 
   } else {
     this.layoutVersion = localStorage.getItem("layout_version"); 
     if (this.layoutVersion === "dark-only") {
       document.body.classList.add("dark-only");
     } else {
       document.body.classList.add("light-only");

     }
   }
   this.userRegistId = JSON.parse(localStorage.getItem('user_id'));
   this.merchantId = JSON.parse(localStorage.getItem('merchant_id'));

  };
};
